import type { ICompetitionPromotionTypeInfo } from '../../../../repositories/auction/entities/AnnouncementsBets/CompetitionPromotionTypeInfo';
import { ICompetitorService } from '../../../../reducers/v2';
import { mapPromotionType } from './mapPromotionType';
import { mapCompetitionLevel } from './mapCompetitionLevel';

export function mapCompetitions(competitions: ICompetitionPromotionTypeInfo[]): ICompetitorService[] {
  return competitions.map(competition => ({
    promotionType: mapPromotionType(competition.promotionType),
    competitionLevel: mapCompetitionLevel(competition.competitionLevel),
    amount: competition.amount,
  }));
}
